import React, { Component } from 'react'
import Config from "../../Util/config";
import BotaoVisualizarItem from './BotaoVisualizar';
import HttpUtil from '../../Util/httpUtil';
import ModalConfirmacao from './../Modulo/ModalConfirmacao';

// SignalR loaded via CDN in index.html — available as window.signalR
const signalR = window.signalR;

class BotaoImportacao extends Component {
    constructor(props) {
        super(props);
        this.state = ({
            lista: [],
            data: this.props.data,
            porcentagem: 0,
            ultimoRegValidado: '',
            idArquivo: this.props.data.id,
        });

        this.confirmacao = React.createRef();

        if (this.props.data.status === 'Ativo') {
            let idAnalise = this.props.data.idAnalise;
            let moduloEfd = this.props.data.moduloEfd;

            this._connection = new signalR.HubConnectionBuilder()
                .withUrl(Config.urls.SIGNALR_HUB_URL)
                .withAutomaticReconnect()
                .build();

            this._connection.start().then(() => {
                this._connection.invoke('IniciarProgressoImportacao', idAnalise, moduloEfd);
            });

            this._connection.on('AtualizarStatusFront', (progresso, statusProgresso, ultimoRegValidado) => {
                if (statusProgresso != 'Ativo') {
                    this.state.data.status = statusProgresso;
                    //Atualiza o componente quando o status da requisição é alterada
                    this.forceUpdate();
                    //desconecta ao alterar o status
                    this._connection.invoke('PararProgressoImportacao').then(() => this._connection.stop());
                    this.consultaDivergencias();
                }
                else {
                    //Atualiza o progresso
                    this.setState({ porcentagem: progresso, ultimoRegValidado: ultimoRegValidado });
                }
            });

            this._connection.onreconnected(() => {
                this._connection.invoke('IniciarProgressoImportacao', idAnalise, moduloEfd);
            });
        }
    }

    componentWillUnmount() {
        //desconecta ao desmontar o componente
        if (this._connection) {
            this._connection.invoke('PararProgressoImportacao').catch(() => {}).finally(() => this._connection.stop());
        }
    }

    consultaDivergencias = () => {
        return new Promise((resolve, reject) => {
            let urlApi = `${Config.urls.API_URL_BASE}HistoricoArquivos/BuscarQuantidadeDivergenciasAnalise/${this.state.data.id}/${this.state.data.moduloEfd}`;
            HttpUtil.eco_GET(urlApi, (response) => {
                resolve({ resposta: response.data });
            }, () => {
                console.log("Error ExibirErrosEstrutura");
            });
        }).then(res => {
            this.props.atualizarDivergencias(this.state.data.id, res.resposta);
        });
    };

    cancelarArquivo = () => {
        new Promise((resolve, reject) => {
            let url = `${Config.urls.API_URL_BASE}Upload/CancelarProcessamento/${this.state.idArquivo}`;
            HttpUtil.eco_GET(url, (response) => {
                resolve({ rows: response.data });
            }, () => { console.log("Error"); });
        }).then(() => {
            this.props.action();
        });
    }

    confirmarcancelamento = () => {
        this.confirmacao.current.alterarVisibilidadeModal();
    }

    setarBotaoVisualizar = (data) => {
        if (this.state.data.status == 'Ativo')
            return (
                <div>
                    <a className="progress eco-progress baby-blue" onClick={this.confirmarcancelamento}>
                        <span className={this.state.porcentagem == 0 ? 'preparando' : (this.state.ultimoRegValidado ? 'auditando' : 'processando')}></span>
                        <div className="progress-bar progress-bar-striped progress-bar-animated baby-blue" role="progressbar" aria-valuenow="87" aria-valuemin="0" aria-valuemax="100" style={{ width: ('' + this.state.porcentagem + '%') }}>
                        </div>
                    </a>
                    <ModalConfirmacao ref={this.confirmacao} mensagemAlerta="Deseja realmente cancelar o processamento ?" action={this.cancelarArquivo} />
                </div>);
        else if (this.state.data.status.toLowerCase() == 'cancelado') {
            return (<a className="ecobtn fat vazado vermelho">Cancelado</a>);
        }
        else
            return (
                <div>
                    <BotaoVisualizarItem data={data} origem="arquivos" />
                </div>)
    }

    render() {
        return (this.setarBotaoVisualizar(this.state.data));
    }
}

export default BotaoImportacao;



// WEBPACK FOOTER //
// ./src/Componente/Arquivos/BotaoImportacao.jsx